import React, { useEffect, useState } from 'react';
import dynamic from 'next/dynamic';
import { useRouter } from 'next/router';
import { Button, Col, Row, Typography } from 'antd';
import CardArticleHB from 'src/components/Card/ArticleHB';
import CardArticleHB2 from 'src/components/Card/ArticleHB2';
import classes from './index.module.less';
const CardArticleHBSlider = dynamic(() => import('src/components/Card/ArticleHBSlider'));
const ReadArticleContainer = (props: any) => {
  const router = useRouter();
  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);
  const getTitle = () => {
    if (router.pathname === '/kalender-kesuburan') return 'Artikel program hamil untuk Mama';
    if (router.pathname === '/kalender-hpl') return 'Artikel Kehamilan untuk Mama';
    return 'Bacaan untuk Mama';
  };
  const renderCards = () => {
    if (!mounted) return null;
    if (router.pathname === '/kalender-kesuburan' || router.pathname === '/kalender-hpl') {
      return <CardArticleHB data={props.records} />;
    }
    if (router.pathname === '/') {
      return <CardArticleHBSlider data={props.artikel} />;
    }
    return <CardArticleHB2 data={props} />;
  };
  return <div className={classes['page-body-wrap']}>
			<div className="container">
				<div style={{
        backgroundColor: '#fff'
      }}>
					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							<div className={classes.headContact}>
								<h2 className={classes.title}>{getTitle()}</h2>
								<Typography className={classes.paragraph}>
									Semua yang Mama butuhkan, dari kehamilan hingga merawat si kecil, ada di sini Ma!
								</Typography>
							</div>
						</Col>
					</Row>

					<Row>
						<Col md={24} sm={24} xs={24} lg={24} xl={24}>
							{renderCards()}
						</Col>
					</Row>

					<div className={classes.btnFooter}>
						<Button className={classes.btn} href="/artikel" size="large" id="home-lihat-semua-artikel">
							Lihat Semua Artikel
						</Button>
					</div>
				</div>
			</div>
		</div>;
};
export default ReadArticleContainer;